(function () {
  customerAccountController.$inject = ["API_URL", "$http", "$q", "$timeout", "$rootScope", "$filter"];
  angular.module('calendarApp').controller('CustomerAccountController', customerAccountController);

  function customerAccountController(API_URL, $http, $q, $timeout, $rootScope, $filter) {
    var account = this,
        throbber = $rootScope.throbber;

    var init = function init() {
      // Need customer appointment and transaction information.
      // Need calendar settings.
      // Need an api to delete appointments and refund credits if that is how the appointment was paid for.
      var promises = [$http.get(API_URL + '/api/v1/calendar/customer/appointment'), $http.get(API_URL + '/api/v1/calendar/customer/transaction')];
      throbber.show();
      account.paginationObject = {};
      $q.all(promises).then(function (replies) {
        throbber.hide();
        replies.forEach(function (reply) {
          var response = reply.data;

          if (!response.success) {
            var msg = $filter('calendarLabel')('Sorry but there was an error with this request: ') + response.msg;
            throbber.showError(msg);
          }
        });
        var appointmentInfo = replies[0].data;
        account.appointments = appointmentInfo.appointments;
        account.paginationObject = {
          count: appointmentInfo.count,
          page: appointmentInfo.page,
          limit: appointmentInfo.limit || 10
        };
        customerCanDeleteAppointments();
        account.transactions = replies[1].data.transactions;
      });
      $timeout(function () {
        initTabs();
      }, 0);
    };

    init();

    account.deleteAppointment = function ($index, appointment) {
      var confirmMessage = $filter('calendarLabel')('Please confirm you would like to delete this appointment');

      if (!confirm(confirmMessage)) {
        return;
      }

      throbber.show();
      $http.delete(API_URL + '/api/v1/calendar/customer/appointment/' + appointment._id).then(function (reply) {
        var response = reply.data;

        if (!response.success) {
          throbber.showError('Sorry but there was an error with this request. Please try again or contact support@smoothbook.co');
          return;
        }

        var deleteMessage = $filter('calendarLabel')('Appointment deleted successfully');
        throbber.hide(deleteMessage);
        account.appointments.splice($index, 1);
      });
    };

    account.getAppointments = function (options) {
      var params = {
        page: options.page || 0,
        perpage: options.perpage || 10,
        pastonly: typeof account.pastOnly !== 'undefined' ? account.pastOnly : false
      };
      throbber.show();
      $http.get(API_URL + '/api/v1/calendar/customer/appointment', {
        params: params
      }).then(function (reply) {
        throbber.hide();
        var response = reply.data;

        if (!response.success) {
          throbber.showError(response.msg);
          return;
        }

        account.appointments = response.appointments;
        account.paginationObject = {
          count: response.count,
          page: response.page,
          limit: response.limit || 10
        };
      });
    };

    account.changePage = function (page) {
      account.getAppointments({
        page: page
      });
    };

    function customerCanDeleteAppointments() {
      var closestCanCancel = smooth.calendarSettings.closestcancancel; // Check if the customer is allowed to delete appointments

      if (!smooth.calendarSettings.customercancancel) {
        account.hideDelete = true;
        return;
      } // Now go through all of the appointments and determine which are allowed to be deleted according
      // to config.


      var cancelMoment = moment().add(closestCanCancel, 'hours');

      for (var i = 0; i < account.appointments.length; i++) {
        if (moment.unix(account.appointments[i].start).isBefore(cancelMoment)) {
          account.appointments[i].hideDelete = true;
        }
      }
    }

    function initTabs() {
      $('.tab-select').on('click', function (ev) {
        ev.preventDefault();
        var $parentContainer = $(this).closest('.tab-container');
        $parentContainer.find('.nav-tabs > li').removeClass('active');
        $parentContainer.find('.tab-pane').removeClass('active');
        var panelID = $(this).attr('id'); // Change content depending on which tab has been selected.

        if (panelID === 'tab_past_appointments') {
          account.pastOnly = true;
          account.getAppointments({});
        } else {
          account.pastOnly = false;
          account.getAppointments({});
        }

        $parentContainer.find('.' + panelID).addClass('active');
        $(this).closest('li').addClass('active');
      });
    }
  }
})();